<template>
  <a-card size="small">
    <div class="title-container">
      <span>流水线成功率</span>
    </div>
    <div :id="id" :style="{ height: height, width: width }" />
  </a-card>
</template>

<script>
export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    executeItems: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      id: 'ci-execute-num-charts',
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + params[1].name + '</b><br/>';
            formatter += params[1].seriesName + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[1].value + '</b> %</span><br/>';
            return formatter;
          }
        },
        grid: {
          top: '8%',
          left: '3%',
          right: '4%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: [
          {
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: -10,
            height: 18,
            endValue: 18
          }
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getExecuteDetail();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/grid');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(this.id));
    this.getExecuteDetail();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    getExecuteDetail() {
      const x_axis = [];
      const yMax = 100;
      const y_axis = [];
      const succ_axis = [];
      if (this.executeItems) {
        this.executeItems.forEach(
          item => {
            x_axis.push(item.team_name);
            y_axis.push(yMax);
            succ_axis.push((parseFloat(item.success_rate) * 100).toFixed(0));
          }
        );
        this.option.xAxis[0].data = x_axis;
        this.option.series = [
          {
            // 背景系列
            type: 'bar',
            itemStyle: { color: 'rgba(180, 180, 180, 0.2)' }, // 背景色
            barGap: '-100%', // 使得背景系列与主数据系列重叠
            data: y_axis, // 使用最大值作为数据以填充整个图表
            animation: false, // 关闭渲染动画，可提高性能
            barWidth: '50%'
          },
          {
            // 主数据系列
            type: 'bar',
            showBackground: false, // 关闭ECharts默认背景
            barWidth: '50%',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%'
            },
            name: '成功率',
            data: succ_axis
          }
        ];
        this.drawChart();
      }
    }
  }
};
</script>
